// extracted by mini-css-extract-plugin
export var followUp = "_page-content-module--follow-up--bd88f";
export var pageContentStandard = "_page-content-module--page-content-standard--ca380";
export var pageContentWithoutPadding = "_page-content-module--page-content-without-padding--28523";